<template>
     <el-dialog title="添加代理" :visible.sync="addCsDialog" width="35%" top="5vh" center style="border: 1px solid #01DFD7" :close-on-click-modal = false
               :close-on-press-escape = false v-loading="loading"  element-loading-text="请求处理中" element-loading-spinner="el-icon-loading"  
               element-loading-background="rgba(0.8, 0, 0, 0.3)" @close="closeDialog">
        <el-card>
            <el-form ref="detailDialog" :model="csForm" label-width="80px">
                <el-form-item label="代理账号" :required="true">
                    <el-input v-model="csForm.account" placeholder="代理手机号"></el-input>
                </el-form-item>
                <el-form-item label="代理类型" align="left">
                <el-radio-group v-model="csForm.type" @change="selectType()">
                    <el-radio :label="global.cs_type[1].code" >{{ global.cs_type[1].message }}</el-radio>
                    <el-radio :label="global.cs_type[0].code" >{{ global.cs_type[0].message }}</el-radio>
                </el-radio-group>
                </el-form-item>
                <el-form-item label="主体名称">
                <el-input v-model="csForm.subjectName" placeholder="代理名称"></el-input>
                </el-form-item>
                <el-form-item label="性别" align="left">
                <el-radio-group v-model="csForm.gender" @change="chooseGender">
                    <el-radio label="0">男</el-radio>
                    <el-radio label="1">女</el-radio>
                </el-radio-group>
                </el-form-item>
                <el-form-item label="邮箱"><el-input v-model="csForm.email" placeholder="邮箱" clearable></el-input></el-form-item>
                <el-form-item label="地区">
                    <el-select v-model="csForm.province" clearable placeholder="省" @change="provinceChoose" style="width:160px">
                        <el-option v-for="item in this.province" :key="item.code" :label="item.value" :value="item.code" ></el-option>
                    </el-select>
                    <el-select v-model="csForm.city" clearable placeholder="市" @change="cityChoose" style="width:160px">
                        <el-option v-for="item in this.city" :key="item.code" :label="item.value" :value="item.code"></el-option>
                    </el-select>
                    <el-select v-model="csForm.area" clearable placeholder="区" style="width:160px" @change="areaChoose">
                        <el-option v-for="item in this.area" :key="item.code" :label="item.value" :value="item.code"></el-option>
                    </el-select>
                    </el-form-item>
                <el-form-item label="地址"><el-input v-model="csForm.address" placeholder="地址" clearable></el-input></el-form-item>
                <el-form-item label="开通分润" align="left">
                <el-radio-group v-model="csForm.rewardFlag">
                    <el-radio label="1">是</el-radio>
                    <el-radio label="0">否</el-radio>
                </el-radio-group>
                </el-form-item>
                <el-form-item label="分润比例" v-if="csForm.rewardFlag == '1'">
                <el-input v-model="csForm.rewardPercent" :disabled="false" placeholder="分润比例" clearable></el-input>
                </el-form-item>
                <el-form-item label="分润比例" v-else>
                <el-input v-model="csForm.rewardPercent" :disabled="true" placeholder="分润比例" clearable></el-input>
                </el-form-item>
            </el-form>
        </el-card>
        <span slot="footer" class="dialog-footer">
            <el-button style="background-color:#A9F5F2;margin: 0" @click="addCsDialog = false">取消</el-button>
            <el-button style="background-color:#A9F5A9" @click="addCs()">确定</el-button>
        </span>
    </el-dialog>
</template>
<script>
import {addCs} from "../../api/relation/csrelation";
export default {
    data() {
        return {
            addCsDialog: false,
            loading: false,
            csForm: {
                account: "",
                type: "0",
                typeStr: "个人",
                subjectName: "",
                gender: "0",
                genderStr: "",
                email: "",
                province: "",
                provinceStr: "",
                city: "",
                cityStr: "",
                area: "",
                areaStr: "",
                address: "",
                rewardFlag: "1",
                rewardPercent: "",
            },
            global: '',
            province: '',
            city: '',
            area: '',
            requestSucceed: false
        }
    },
    methods: {
        init(){
            this.addCsDialog = true;
        },

        /**
         * 代理类型选择
         */
        selectType(value){
            this.csForm.typeStr = value === "0" ? "个人" : "企业";
        },

        /**
         * 性别选择
         */
        chooseGender(value){
            this.csForm.genderStr = value === "0" ? "男" : "女"
        },

        /**
         * 添加代理
         */
        addCs(){
            if(this.csForm.account === null || this.csForm.account === undefined || this.csForm.account === ""){
                this.$message({
                    message: "账号不能为空",
                    type: "success",
                    duration: 1500,
                });
                this.loading = false;
                return;
            }
            addCs(this.csForm).then(result=>{
                this.$emit('add-succeed','添加成功')
                this.$message({
                    message: "操作成功",
                    type: "success",
                    duration: 1500,
                });
                this.addCsDialog = false;
            })
        },

        /**
         * 关闭弹窗
         */
        closeDialog(){
            this.csForm.account = "";
            this.csForm.type = "0";
            this.csForm.typeStr = "个人";
            this.csForm.subjectName = "";
            this.csForm.gender = "0";
            this.csForm.genderStr = "男";
            this.csForm.email = "";
            this.csForm.province = "";
            this.csForm.provinceStr = "";
            this.csForm.city = "";
            this.csForm.cityStr = "";
            this.csForm.area = "";
            this.csForm.areaStr = "";
            this.csForm.address = "";
            this.csForm.rewardFlag = "1";
            this.csForm.rewardPercent = "";
            this.requestSucceed = false;
        },

        /**
        * 省下拉框选择触发事件
        */
        provinceChoose(value){
            this.csForm.city = '';
            this.csForm.area = '';
            for (let item of this.province) {
            if (value == item.code) {
                this.csForm.provinceStr = item.value;
                this.city = item.childrenDictList
            }
            }
        },

        /**
        * 市下拉框选择触发事件
        */
        cityChoose(value){
            this.csForm.area = '';
            for (let item of this.city) {
                if (value == item.code) {
                    this.csForm.cityStr = item.value;
                    this.area = item.childrenDictList;
                }
            }
        },

        /**
        * 区下拉框选择触发事件
        */
        areaChoose(value){
            for (let item of this.city) {
                if (value == item.code) {
                    this.csForm.areaStr = item.value;
                }
            }
        },

    },
    created() {
        this.global = JSON.parse(sessionStorage.getItem("global"));
        this.province = JSON.parse(sessionStorage.getItem("dict")).area;
    }
}
</script>
<style scoped>

</style>


// WEBPACK FOOTER //
// src/pages/relation/addCs.vue